import {ICON_TYPES} from '../constants';

export const NoPropertyImage = (): JSX.Element => {
  return (
    <svg
      width='48'
      height='49'
      viewBox='0 0 48 49'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M30 42.5L18 38.3L8.7 41.9C8.03333 42.1667 7.41667 42.0917 6.85 41.675C6.28333 41.2583 6 40.7 6 40V12C6 11.5667 6.125 11.1833 6.375 10.85C6.625 10.5167 6.96667 10.2667 7.4 10.1L18 6.5L30 10.7L39.3 7.1C39.9667 6.83333 40.5833 6.90833 41.15 7.325C41.7167 7.74167 42 8.3 42 9V37C42 37.4333 41.875 37.8167 41.625 38.15C41.375 38.4833 41.0333 38.7333 40.6 38.9L30 42.5ZM28 37.6V14.2L20 11.4V34.8L28 37.6ZM32 37.6L38 35.6V11.9L32 14.2V37.6ZM10 37.1L16 34.8V11.4L10 13.4V37.1Z'
        fill='#B4D9F3'
      />
    </svg>
  );
};

NoPropertyImage.iconType = ICON_TYPES.NO_PROPERTY_IMAGE;
